import * as angular from 'angular';
import * as moment from 'moment';

import * as events from '../../common/events';

import { RefreshClickData } from '../../models';
import { ICurrentApplicationService } from '../data/currentApplication.service';
import { IDateRangeService } from '../general';

export interface INavigationHistory {
    groupGuid?: string;
    icon: string;
    interval?: { begin: moment.Moment, end: moment.Moment };
    name: string;
    page: string;
    params: any;
}

export interface INavigationHistoryService {
    getNavigationHistories(): INavigationHistory[];
    setNavigationHistory(history: INavigationHistory, updateIfLast?): void;
    updateLastHistory(name: string, pagePrefix?: string, groupGuid?: string): void;
}

export class NavigationHistoryService implements INavigationHistoryService {
    static serviceId = 'navigationHistoryService';

    private _histories: { [name: string]: INavigationHistory[] } = {};

    static $inject = ['$rootScope', 'currentApplicationService', 'dateRangeService'];
    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _currentApplicationService: ICurrentApplicationService,
        private _dateRangeService: IDateRangeService
    ) {

        // TODO save dates, from param, else from current interval
        this._$rootScope.$on('$stateChangeSuccess', (event, toState: angular.ui.IState, toParams, fromState: angular.ui.IState, fromParams) => {
            if (!toState.data || !toState.data.ignoreHistory) {
                const interval: any = this.getInterval(toParams);
                if (!toState.data) {
                    console.log(`Page ${toState.name} has no data`);
                }
                const newHisto: INavigationHistory = {
                    page: toState.name,
                    name: toState.data ? toState.data.displayName as string : toState.name,
                    icon: toState.data ? toState.data.icon as string : '',
                    params: angular.copy(toParams) as {},
                    interval: interval
                };

                this.removeFromLast(newHisto, 10);
                this.setNavigationHistory(newHisto);
            }
        });

        this._$rootScope.$on(events.refreshClick, (_event: angular.IAngularEvent, data: RefreshClickData) => {
            const all = this.getCurrentHistories();
            if (data && all && all.length > 0) {
                const last = all[0];
                last.interval = {
                    begin: moment(data.beginDate),
                    end: moment(data.endDate)
                };
                this._$rootScope.$broadcast(events.navigationHistoryUpdated);
            }
        });
    }

    private getInterval(toParams: any) {
        const interval: any = {};

        if (this._dateRangeService.initialized()) {
            interval.begin = moment(this._dateRangeService.beginDate() as string);
            interval.end = moment(this._dateRangeService.endDate() as string);
        }

        if (toParams) {
            if (toParams.beginDate) {
                interval.begin = moment(toParams.beginDate);
            }
            if (toParams.endDate) {
                interval.end = moment(toParams.endDate);
            }
        }
        return interval;
    }

    getNavigationHistories(): INavigationHistory[] {
        return this.getCurrentHistories();
    }

    setNavigationHistory(history: INavigationHistory, updateIfLast = false): void {
        const histo = this.getCurrentHistories();

        if (updateIfLast && histo.length > 0 && histo[0].page === history.page) {
            histo[0] = history;
        } else {
            histo.unshift(history);
        }

        this._$rootScope.$broadcast(events.navigationHistoryUpdated);
    }

    updateLastHistory(name: string, pagePrefix?: string, groupGuid?: string): void {
        const all = this.getCurrentHistories();

        if (all && all.length > 0) {
            if (pagePrefix === undefined || all[0].page.substring(0, pagePrefix.length) === pagePrefix) {
                all[0].name = name;
                if (groupGuid) {
                    all[0].groupGuid = groupGuid;
                }
                this._$rootScope.$broadcast(events.navigationHistoryUpdated);
            }
        }
    }

    private removeFromLast(histo: INavigationHistory, count: number) {
        const all = this.getCurrentHistories();

        for (let i = 0; i < count && i < all.length; i++) {
            const isSame = histo.page === all[i].page &&
                histo.interval.begin.isSame(all[i].interval.begin) &&
                histo.interval.end.isSame(all[i].interval.end) &&
                histo.groupGuid === all[i].groupGuid;

            if (isSame) {
                all.splice(i, 1);
                break;
            }
        }
    }

    private getCurrentHistories(): INavigationHistory[] {
        let result = [];
        const appConfig = this._currentApplicationService.getApplicationConfiguration();

        if (appConfig && appConfig.name) {
            if (!this._histories[appConfig.name]) {
                this._histories[appConfig.name] = [];
            }
            result = this._histories[appConfig.name];
        }

        return result;
    }
}